import React from 'react';
import CostcoLocationTemplate from '../../components/CostcoLocationTemplate';

const Auburn = () => (
  <CostcoLocationTemplate
    warehouseName="Auburn"
    suburb="Lidcombe"
    state="New South Wales"
    stateShort="NSW"
    address="2 Parramatta Rd, Lidcombe NSW 2141"
    path="/costco/auburn"
    nearbySuburbs={[
      'Auburn',
      'Lidcombe',
      'Berala',
      'Regents Park',
      'Rookwood',
      'Granville',
      'Silverwater',
      'Newington',
      'Olympic Park',
      'Homebush',
    ]}
    description="Serving Costco Executive Members near the Auburn warehouse in Lidcombe. Whether you're buying your first home in Western Sydney or refinancing an existing property, our team can help you access competitive loan rates — and earn a Costco Shop Card when your loan settles."
    localContext={[
      {
        title: 'Western Sydney Property Market',
        description:
          'Auburn and surrounding suburbs offer some of the most accessible entry points into the Sydney property market. Strong rental yields and ongoing urban renewal make this corridor attractive for both first home buyers and investors.',
      },
      {
        title: 'Parramatta CBD Growth',
        description:
          'With Parramatta rapidly emerging as Sydney\'s second CBD, suburbs within the Auburn-Lidcombe corridor are benefiting from infrastructure investment, new commercial precincts, and rising property values.',
      },
      {
        title: 'Transport & Connectivity',
        description:
          'Excellent rail links via Auburn and Lidcombe stations, proximity to the M4 motorway, and the upcoming Sydney Metro West make this area highly connected for commuters and families alike.',
      },
    ]}
    faqs={[
      {
        q: 'How does the Costco Shop Card offer work for members near Auburn?',
        a: 'When you settle a home loan, car loan, or other eligible loan through Manage Your Loans, you receive a Costco Shop Card as a reward. The value is based on your fully drawn-down loan amount. You must be a Costco Executive Member at the time of settlement. The Shop Card can be used at any Costco warehouse, including Auburn.',
      },
      {
        q: 'Am I eligible for a Costco Shop Card if I live near Auburn?',
        a: 'Yes — the offer is available to Costco Executive Members Australia-wide. If you shop at the Auburn warehouse and settle an eligible loan through Manage Your Loans, you qualify. There is no geographic restriction on the lending side.',
      },
      {
        q: 'What is the property market like around Auburn and Lidcombe?',
        a: 'The Auburn-Lidcombe area offers a mix of apartments, townhouses, and freestanding homes at price points below the Sydney median. Proximity to Parramatta CBD, Olympic Park, and strong transport links continue to drive demand and long-term capital growth.',
      },
      {
        q: 'Can I refinance my existing home loan and still earn a Shop Card?',
        a: 'Yes. Refinancing is an eligible loan type. If you refinance through Manage Your Loans and you are a Costco Executive Member, you will receive a Shop Card based on the settled loan amount. Terms and conditions apply.',
      },
    ]}
    suburbData={{
      suburb: 'Lidcombe',
      medianHouse: '$1,200,000',
      medianUnit: '$580,000',
      daysOnMarket: '30 days',
      rentalYield: '3.2%',
      population: '18,000',
      distanceToCostco: '1 km',
    }}
    surroundingSuburbs={[
      { suburb: 'Auburn', medianHouse: '$1,050,000', medianUnit: '$530,000', daysOnMarket: '32 days' },
      { suburb: 'Berala', medianHouse: '$1,100,000', medianUnit: '$520,000', daysOnMarket: '28 days' },
      { suburb: 'Regents Park', medianHouse: '$1,020,000', medianUnit: '$510,000', daysOnMarket: '30 days' },
      { suburb: 'Granville', medianHouse: '$980,000', medianUnit: '$490,000', daysOnMarket: '27 days' },
      { suburb: 'Silverwater', medianHouse: '$1,150,000', medianUnit: '$560,000', daysOnMarket: '25 days' },
      { suburb: 'Newington', medianHouse: '$1,280,000', medianUnit: '$680,000', daysOnMarket: '22 days' },
      { suburb: 'Olympic Park', medianHouse: '$1,350,000', medianUnit: '$720,000', daysOnMarket: '20 days' },
      { suburb: 'Homebush', medianHouse: '$1,300,000', medianUnit: '$650,000', daysOnMarket: '24 days' },
      { suburb: 'Rookwood', medianHouse: '$1,080,000', medianUnit: '$500,000', daysOnMarket: '31 days' },
    ]}
  />
);

export default Auburn;
